

let headerSlideshow = null;
let partnerSlider = null;


if (document.querySelector('.ce_rsce_headerSlideshow')){
    headerSlideshow = new Swiper(".ce_rsce_headerSlideshow", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 4500,
            disableOnInteraction: true,
        },
        pagination: {
            el: ".ce_rsce_headerSlideshow .swiper-pagination",
            dynamicBullets: true,
        },
        navigation: {
            nextEl: ".ce_rsce_headerSlideshow .swiper-button-next",
            prevEl: ".ce_rsce_headerSlideshow .swiper-button-prev",
        },
    });

}

